import type { ThemeManifest } from "../types";

export const manifest: ThemeManifest = {
  id: "b2b",
  displayName: "B2B — Enterprise",
  description: "Compact, professional layout for enterprise clients.",
  extends: "default",
};
